export * from './proposal-segment.pipe';
